module.exports = __webpack_public_path__ + "img/filter-type-legs.8af8369a.svg";